<div class="feedback-prompt">
  <span class="feedback-prompt-label">Was this conversation helpful?</span>
  <div class="feedback-thumbs">
    <button type="button" class="feedback-thumb" [disabled]="$submitting()" (click)="ratePositive()" aria-label="Give positive feedback">
      <i class="fa-regular fa-thumbs-up"></i>
    </button>
    <button type="button" class="feedback-thumb" [disabled]="$submitting()" (click)="openNegative()" aria-label="Give negative feedback">
      <i class="fa-regular fa-thumbs-down"></i>
    </button>
  </div>
  <button type="button" class="feedback-dismiss" (click)="dismiss()" aria-label="Dismiss">
    <i class="fa-regular fa-xmark"></i>
  </button>
</div>

@if ($view() === 'negative') {
  <div class="feedback-modal-backdrop" (click)="cancel()"></div>
  <div class="feedback-modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <h2 class="feedback-modal-title">Give feedback</h2>
    <label for="feedback-details">Please provide details: (optional)</label>
    <textarea #detailsInput id="feedback-details" rows="3" [value]="$reason()" (input)="onReasonInput($event)" placeholder="What was unsatisfying about this response?" autocomplete="off"></textarea>
    <p class="feedback-modal-note">Submitting this shares this conversation with the WorkBuddy team to help improve the assistant.</p>
    <div class="feedback-modal-actions">
      <button type="button" class="cancel" (click)="cancel()">Cancel</button>
      <button type="button" class="submit" [disabled]="$submitting()" (click)="submitNegative()">Submit</button>
    </div>
  </div>
}
